import EntityModel from '@/common/models/entity-model';

export default class TagModel extends EntityModel {
    hydrate({
        id = null,
        name = null,
        createdTime = null,
        updatedTime = null,
        customers = [],
    } = {}) {
        this.id = id;
        this.name = name;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.customers = customers;
    }

    getPayload() {
        return {
            id: this.id,
            name: this.name,
        };
    }

    getName() {
        return this.name;
    }
}
